<script setup>
const props = defineProps({
  title: String,
  text: Object,
  link: Object,
  image: Object,
});
</script>

<template>
  <section class="l-container p-section">
    <div
      class="l-row items-center flex-col"
      :class="text?.position === 'left' ? 'md:flex-row-reverse' : 'md:flex-row'"
    >
      <div
        class="w-full md:w-1/2 p-col mb-lg md:mb-0"
        :class="
          text?.position === 'left'
            ? 'md:pl-lg lg:pl-xl xl:pl-2xl'
            : 'md:pr-lg lg:pl-2xl xl:pr-2xl'
        "
      >
        <picture v-if="image">
          <source
            v-if="image.type !== 'svg' && image?.url?.webp"
            :srcset="image?.url?.webp"
            type="image/webp"
          />
          <source
            v-if="
              image.type !== 'svg' && image.type !== 'png' && image?.url?.jpg
            "
            :srcset="image?.url?.jpg"
            type="image/jpeg"
          />
          <img
            v-if="image.type === 'jpg' && image?.url?.jpg"
            class="block w-full"
            :src="image?.url?.jpg"
            :alt="image?.alt"
            :title="image?.title"
          />
          <img
            v-else-if="image.type === 'png' && image?.url?.png"
            class="block w-full"
            :src="image?.url?.png"
            :alt="image?.alt"
            :title="image?.title"
          />
          <img
            v-else
            class="block w-full"
            :src="image?.url?.original"
            :alt="image?.alt"
            :title="image?.title"
          />
        </picture>
      </div>
      <div class="w-full md:w-1/2 flex flex-wrap items-center p-col">
        <div class="w-full" :class="text?.bg">
          <h2 v-if="title" v-html="title" class="hero__title mb-lg h1"></h2>
          <div
            v-if="text?.content"
            v-html="text?.content"
            class="prose"
            :class="text?.bg === 'bg-white' ? 'prose--black' : ''"
          ></div>
          <a
            v-if="link[0]"
            class="btn mt-lg"
            :href="link[0]?.url"
            :target="link[0]?.target"
            :aria-label="link[0]?.accessibilityText"
            >{{ link[0]?.text }}</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
